import { SituacaoFatura } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type FaturasResponsavelFilters = {
  /** Obrigatória: a listagem é das faturas de uma instituição (vai na URL do endpoint). */
  empresa?: IOption<number>
  mes?: IOption<string>
  ano?: IOption<number>
  situacao?: IOption<SituacaoFatura>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<FaturasResponsavelFilters>(
  {
    empresa: undefined,
    mes: undefined,
    ano: undefined,
    situacao: undefined,
  }
)
